import { css } from '@emotion/react';
import styled from '@emotion/styled';
import FONT from '../../styles/emotion/fonts';
import COLORS from '../../styles/emotion/colors3';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';
import Arrow from '../SvgIcons/Arrow';

export const ArrowIcon = styled(Arrow)`
  color: ${COLORS.BLACK_075};
  margin-right: 8px;
  &:hover {
    color: ${COLORS.BLACK_075};
  }
`;

export const BackLink = styled.a`
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  line-height: 24px;
  color: ${COLORS.BLACK_075};
  display: flex;
  align-items: center;
  &:hover {
    color: ${COLORS.BLACK_075};
  }
`;

export const MobileOnlyBackLink = styled(BackLink)`
  display: none;

  ${MEDIA_QUERY_V2.MOBILE} {
    display: flex;
  }
`;

const breadcrumbItemStyles = css`
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  line-height: 22px;
`;

export const LinkItem = styled.a<{ disableBackLink: boolean }>`
  ${breadcrumbItemStyles}
  ${({ disableBackLink }) => {
    return disableBackLink
      ? null
      : css`
          ${MEDIA_QUERY_V2.MOBILE} {
            display: none;
          }
        `;
  }}
  color: ${COLORS.BLACK_075};
  text-decoration: underline;
  &:hover {
    color: ${COLORS.BLACK_075};
    text-decoration: underline;
  }
`;

export const Divider = styled.span<{ disableBackLink: boolean }>`
  ${breadcrumbItemStyles}
  ${({ disableBackLink }) => {
    return disableBackLink
      ? null
      : css`
          ${MEDIA_QUERY_V2.MOBILE} {
            display: none;
          }
        `;
  }}
  color: ${COLORS.BLACK_030};
  margin: 0 8px;
`;

export const TextItem = styled.span<{ disableBackLink: boolean }>`
  ${breadcrumbItemStyles}
  ${({ disableBackLink }) => {
    return disableBackLink
      ? null
      : css`
          ${MEDIA_QUERY_V2.MOBILE} {
            display: none;
          }
        `;
  }}
  color: ${COLORS.BLACK_075};
`;

export const InnerList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
`;

export const InnerListItem = styled.li`
  padding: 0;
  margin: 0;
  ${MEDIA_QUERY_V2.MOBILE_XS} {
    width: 100%;
  }
`;
